import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-clotrimazole-vaginal-cream',
  templateUrl: './clotrimazole-vaginal-cream.component.html',
  imports: [UpsellCardComponent],
})
export class ClotrimazoleVaginalCreamComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.ClotrimazoleVaginalCream;
}
